// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import VueLocalStorage from 'vue-ls'

Vue.config.productionTip = false

var options = {
  namespace: 'vuejs__'
}

Vue.use(VueLocalStorage, options)

Vue.use(VueLazyload, {
  preLoad: 1,
  error: '/static/images/loading-wheel.svg',
  loading: '/static/images/loading-wheel.svg',
  attempt: 3
})

Vue.component('vue-lazypic', {
  props: {
    imgset: {},
    sizes: {},
    className: '',
    imgClass: '',
  },
  template: '<picture :class="className"><template v-for="(img,key) in imgset.uris"><source v-if="sizes[key]" :data-srcset="img" :media="sizes[key]"></template><img v-lazy="imgset.uris.scale_crop_1024x576" :width="imgset.size.width" :height="imgset.size.height" :class="imgClass" /></picture>'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js